<bringoz-button theme="primary" class="full-width"
                (onClick)="onClick()">
  <span>{{'Logout' | translate}}</span>
</bringoz-button>
